import React, { useEffect, useState } from 'react'
// ⌬ 1.1 redux
// import store from './stores/stores';
import { store } from './comm_stores';
import { Provider } from 'react-redux';
import LoginStatus from './LoginStatus';
import ProdKeyPage from './pages/ProdKeyPage';
import ApiGo from './actions/ApiGo';
import Mos from './actions/Mos';

export const ProdKeyCtx = React.createContext();

const App =()=>{
  const [isValidKey, setIsValidKey] = useState(false); // 是否已註冊
  const [refreshLicense, setRefreshLicense] = useState(false); // 畫面刷新/license
  const [hidePanel, setHidePanel] = useState(true); // panel預設關閉
  const [sendCloseFlag, setSendCloseFlag] = useState(false);

  const mos = Mos();

  useEffect(()=>{
    ApiGo.getSystemDesktopOrServer()
    .then(res=>{
      localStorage.setItem("IP", res.client_ip)
    })
    .catch(err=>{console.log(err)})
  }, [])

  useEffect(()=>{         // 後端確認前端是否保持連線用
    if(mos.connectionCheck){
      let localIP = localStorage.getItem("IP")
      let localID = localStorage.getItem("UID")
      mos.sendPayload("verify_client_connection", localIP +","+localID+ ",connected")
      mos.setConnectionCheck(false)
    }
  }, [mos.connectionCheck])

  // window.addEventListener("beforeunload", (event) => {
  //   // ApiGo.check_close_browser(1)                              // 1 關閉，0 取消關閉
  //   // event.preventDefault();
  //   // setTimeout(()=>{ setSendCloseFlag(true) }, [20000])       // 等20秒，若取消關掉，則會送出check close browser api
  //   return event.returnValue = ''; /*✔️ Need this for pseudo elements to work! */
  // });

  return(
    <>
      {
        // isValidKey ?
        <Provider store={store}>
          <ProdKeyCtx.Provider value={{
            refreshLicense: refreshLicense,
            setRefreshLicense: setRefreshLicense,
            hidePanel: hidePanel,
            setHidePanel: setHidePanel,
          }}>
            <LoginStatus />
          </ProdKeyCtx.Provider>
        </Provider>
          // : <ProdKeyPage setData={setIsValidKey} />
      }
    </>
  );

}
export default App;